import { Flex, type MantineStyleProp, Text } from "@mantine/core";
import type { PropsWithChildren, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

interface ResultsSectionProps {
  style?: MantineStyleProp;
  title: ReactNode;
  titleBadge?: ReactNode;
}

export const ResultsSection = ({
  children,
  style = {},
  title,
  titleBadge,
}: PropsWithChildren<ResultsSectionProps>) => {
  return (
    <Flex
      className={twMerge([
        "border",
        "border-uw-gray-1",
        "gap-3",
        "px-5",
        "py-4",
        "rounded-md",
      ])}
      direction="column"
      style={style}
    >
      <Flex direction="row" justify="space-between">
        <Flex direction="column">
          {typeof title === "string" ? (
            <Text className="font-semibold">{title}</Text>
          ) : (
            title
          )}
        </Flex>
        {titleBadge}
      </Flex>
      {children}
    </Flex>
  );
};
